import { DatePicker } from "antd"
import { Link, useNavigate, useParams } from "react-router-dom"
import useApi from "../../core/customhook/useApi"
import dayjs, { Dayjs } from "dayjs"
import { useEffect, useState } from "react"
import Swal from "sweetalert2"
import { is_manager } from "../../environment"
import Loader from "../../core/common/selfLoder";
import CollapseHeader from "../../core/common/collapse-header/collapse-header"
// This is manager approval page
interface FormData {
    ResignationDate: string
    RequestedRelievingDate: string
    RequestedRelievingDateAsPerPolicy: string
    NoticePeriodRequestDays: string
    NoticePeriodDifferenceDays: string | number
    Reasons: string
    Remarks: string
    Status: string
    employeeId: string
    emailId: string
    DOJ: string
    employeeName: string
    gender: string
    department: string
    designation: string
    location: string
    DOB: string
    EmployeeStatus: string
    offboardingDocuments: string[]
    Grade: string
    LastWorkingDate: string | null
    ManagerRemark: string
}


const ManagerViewResignation = () => {
    const [approvalStatus, setApprovalStatus] = useState<string | null>(null);
    const [formData, setFormData] = useState<FormData>({
        ResignationDate: "",
        RequestedRelievingDate: "",
        RequestedRelievingDateAsPerPolicy: "",
        NoticePeriodRequestDays: "",
        NoticePeriodDifferenceDays: "",
        Reasons: "",
        Remarks: "",
        Status: "",
        employeeId: "",
        emailId: "",
        DOJ: "",
        employeeName: "",
        gender: "",
        department: "",
        designation: "",
        location: "",
        DOB: "",
        EmployeeStatus: "",
        offboardingDocuments: [] as string[],
        Grade: "",
        LastWorkingDate: "",
        ManagerRemark: ""
    });

    const navigate = useNavigate();
    const { Id } = useParams<{ Id: string }>();


    const endpoint = "/api/manager/team-viewresignation"

    const options = { method: "POST" as const, autoCall: true, payload: { id: Id } }

    const { data: getResignationData, loading: resignationData, error, callApi: refetchResignation } = useApi(
        endpoint,
        options
    );


    useEffect(() => {
        if (getResignationData?.data.resignation_date) {
            setFormData(
                (prev) => ({
                    ...prev,
                    ResignationDate: dayjs(getResignationData.data.resignation_date).format("DD-MM-YYYY"),
                    RequestedRelievingDate: dayjs(getResignationData.data.requested_relieving_date).format("DD-MM-YYYY"),
                    RequestedRelievingDateAsPerPolicy: dayjs(getResignationData.data.relieving_date_as_per_policy).format("DD-MM-YYYY"),
                    NoticePeriodRequestDays: getResignationData?.data.notice_period_requested_days || "",
                    Reasons: getResignationData?.data.reason || "",
                    Remarks: getResignationData.data.remarks || "",
                    Status: getResignationData.data.status || "",
                    employeeId: getResignationData.data.employee_id || "",
                    emailId: getResignationData.data.email_id || "",
                    DOJ: getResignationData?.data.join_date || "",
                    employeeName: getResignationData?.data.employee_name || "",
                    department: getResignationData?.data.department || "",
                    designation: getResignationData?.data.designation,
                    location: getResignationData?.data.work_location || "",
                    DOB: getResignationData?.data.date_of_birth || "",
                    gender: "",
                    EmployeeStatus: getResignationData?.data.employee_status || "",
                    // NoticePeriodDifferenceDays: dayjs(formData.ResignationDate).diff(dayjs(formData.RequestedRelievingDate), 'day')
                    NoticePeriodDifferenceDays: "",
                    Grade: getResignationData?.data.band || "",
                    offboardingDocuments: getResignationData?.data?.document_path
                        ? JSON.parse(getResignationData.data.document_path)
                        : [],
                    LastWorkingDate: getResignationData?.data.actual_lwd || "",
                    ManagerRemark: getResignationData?.data.manager_remark || ""
                }));
        }
    }, [getResignationData, Id]);

    useEffect(() => {
        if (!formData.ResignationDate || !formData.RequestedRelievingDate) return;
        // console.log(formData.RequestedRelievingDateAsPerPolicy, "AND", formData.ResignationDate)

        const resignation = dayjs(formData.ResignationDate, "DD-MM-YYYY");
        const relieving = dayjs(formData.RequestedRelievingDateAsPerPolicy, "DD-MM-YYYY");

        if (!resignation.isValid() || !relieving.isValid()) return;

        const diff = relieving.diff(resignation, "day").toString();

        setFormData(prev => {
            if (prev.NoticePeriodDifferenceDays === diff) return prev;

            return {
                ...prev,
                NoticePeriodDifferenceDays: diff,
            };
        });
    }, [formData.ResignationDate, formData.RequestedRelievingDate]);

    // const ResignationFormAcceptance = () => {

    // }

    //accept request
    const {
        data: approve_data,
        loading: approverLoading,

        callApi: callOffboardingProcess,
    } = useApi("/api/manager/offboarding/process", {
        method: "POST",
        autoCall: false,
    })

    // retain request
    const {
        data: reject_data,
        loading: rejectLoading,

        callApi: callRejectApi,
    } = useApi("/api/manager/offboarding-request-rejection", {
        method: "POST",
        autoCall: false,
    })

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.LastWorkingDate) {
            Swal.fire({
                icon: "warning",
                title: "Missing Last working Date",
                text: " Last Working Date are required.",
            });
            return;
        }
        // Validate last working date and manager remarks
        if (!formData.ManagerRemark) {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Manager Remarks are required.",
            });
            return;
        }

        // Ensure a status (Approved/Rejected) is selected via button
        if (!approvalStatus) {
            Swal.fire({
                icon: "warning",
                title: "Action Required",
                text: "Please select Accept or Retain to proceed.",
            });
            return;
        }

        // Confirmation dialog text/colors based on status
        const confirmText =
            approvalStatus === "Approved"
                ? "Do you want to accept this offboarding request?"
                : "Do you want to retain this employee?";
        const confirmButtonText =
            approvalStatus === "Approved" ? "Yes, Accept" : "Yes, Retain";
        const confirmButtonColor =
            approvalStatus === "Approved" ? "#28a745" : "#ffc107"; // green = approve, yellow = retain

        const result = await Swal.fire({
            title: "Are you sure?",
            text: confirmText,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor,
            cancelButtonColor: "#d33",
            confirmButtonText,
            cancelButtonText: "Cancel",
        });

        if (!result.isConfirmed) return;

        // Build payload
        const payload = {
            employee_id: formData.employeeId,
            status: approvalStatus,
            managerRemarks: formData.ManagerRemark || "",
            lastWorkingDay: formData.LastWorkingDate, // already in YYYY-MM-DD format from DatePicker
        };

        try {
            const response = await callOffboardingProcess(payload);

            Swal.fire({
                icon: response.success ? "success" : "error",
                title: response.success
                    ? `Offboarding Request ${approvalStatus}`
                    : `${approvalStatus} Failed`,
                text:
                    response?.message ||
                    `The offboarding request has been ${approvalStatus.toLowerCase()} successfully.`,
            }).then(() => {
                refetchResignation();
                setApprovalStatus(null);
            });;

            // Optionally refresh or navigate after success
            // setRefreshKey(prev => prev + 1);
        } catch (err: any) {
            console.error("Approval error:", err);
            Swal.fire({
                icon: "error",
                title: `${approvalStatus} Failed`,
                text:
                    err?.response?.data?.message ||
                    "Something went wrong while processing the offboarding request.",
            });
        }
    };


    // const rejectOffboardingRequest = async (employeeId: any) => {
    //     const result = await Swal.fire({
    //         title: "Reject Offboarding Request",
    //         text: "Are you sure you want to reject this offboarding request?",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#6c757d",
    //         confirmButtonText: "Retain",
    //         cancelButtonText: "Cancel",
    //     });

    //     if (result.isConfirmed) {
    //         const payload = {
    //             employee_id: employeeId,
    //             // No rejection reason included in the payload anymore
    //         };

    //         try {
    //             const response = await callRejectApi(payload);

    //             Swal.fire({
    //                 icon: response.success === true ? "success" : "error",
    //                 title: response.success === true ? "Offboarding Request Rejected" : "Rejection Failed",
    //                 text: response?.message || "The offboarding request has been rejected.",
    //                 showConfirmButton: true,
    //             });

    //             // setRefreshKey(prev => prev + 1);
    //         } catch (err: any) {
    //             console.error("Failed to reject offboarding request:", err);
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "Rejection Failed",
    //                 text: err?.response?.data?.message || "Something went wrong while rejecting the offboarding request.",
    //                 showConfirmButton: true,
    //             });
    //         }
    //     }
    // };


    return (
        <>
            <Loader loading={resignationData} />
            <div className="page-wrapper">
                <div className="content">

                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Offboarding Application</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Offboarding</li>
                                    <li className="breadcrumb-item active">
                                        Offboarding
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>

                    {/* Main Card */}
                    {getResignationData?.data.resignation_date
                        ? (<div className="card">
                            <form onSubmit={handleSubmit}>
                                <div className="card-header w-full d-flex align-items-center justify-content-between mb-3">
                                    {/* Left: Heading */}
                                    <h5 className="mb-0">Offboarding Request</h5>
                                    {is_manager ?
                                        (<div className="d-flex align-items-center bg-primary rounded-pill py-2 px-2">
                                            <label
                                                className="px-2 me-2 bg-light rounded-pill"
                                                style={{
                                                    backgroundColor: "white",
                                                    color: "black",
                                                }}>
                                                STATUS
                                            </label>
                                            <label className="mb-0 text-uppercase"> {
                                                formData.Status === "Approved" ? "Accepted"
                                                    : formData.Status === "Pending" ? "Pending"
                                                        : formData.Status === "Rejected" ? "Retained"
                                                            : "Withdrawn" // fallback
                                            }
                                            </label>
                                        </div>) : (<></>)}
                                </div>


                                <div className="row">
                                    <div className="row m-1">
                                        {/* Employee Details */}

                                        <div className="col-md-6">
                                            <div className="card h-100">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h5 className="mb-0">Employee Details</h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Employee Name</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter employee name"
                                                                value={formData.employeeName || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Employee ID</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="EMP001"
                                                                value={formData.employeeId || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Date of Birth</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.DOB ? dayjs(formData.DOB, "DD-MM-YYYY").format("DD MMMM YYYY") : formData.DOB}
                                                                disabled
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Date of Joining</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.DOJ ?
                                                                        dayjs(formData.DOJ, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.DOJ}
                                                                readOnly
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Department</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.department || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Designation</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.designation || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Work Location</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.location || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Grade</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.Grade || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Resignation Details */}
                                        <div className="col-md-6">
                                            <div className="card h-100">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h5 className="mb-0">Offboarding Details</h5>
                                                </div>

                                                <div className="card-body">
                                                    {/* Resignation Date */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Resignation Date</label>
                                                        <div className="col-8">
                                                            {/* {isClient && ( */}
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.ResignationDate
                                                                        ? dayjs(formData.ResignationDate, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.ResignationDate
                                                                }
                                                                placeholder="DD-MM-YYYY"
                                                                disabled
                                                                required
                                                            />
                                                            {/* )} */}
                                                        </div>
                                                    </div>

                                                    {/* Relieving Date Requested */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Relieving Date Requested</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.RequestedRelievingDate
                                                                        ? dayjs(formData.RequestedRelievingDate, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.RequestedRelievingDate
                                                                }
                                                                disabled
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Notice Period Requested */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Notice Period Requested</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control"
                                                                min={0}
                                                                value={formData?.NoticePeriodRequestDays}
                                                                placeholder="Enter number of days"
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Notice Period Difference Days */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Notice Period Difference Days</label>
                                                        <div className="col-8">
                                                            <input type="text"
                                                                className="form-control"
                                                                value={formData?.NoticePeriodDifferenceDays || ""}
                                                                readOnly
                                                            // disabled={isViewOnly} 
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Relieving Date As Per Policy */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Relieving Date As Per Policy</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.RequestedRelievingDateAsPerPolicy
                                                                        ? dayjs(formData.RequestedRelievingDateAsPerPolicy, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.RequestedRelievingDateAsPerPolicy
                                                                }
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Reasons */}
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">Reasons</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control"
                                                                value={formData.Reasons ?? ""}
                                                                readOnly
                                                            >
                                                            </input>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">Employee Remarks</label>
                                                        <div className="col-8">
                                                            <textarea
                                                                className="form-control"
                                                                placeholder="Enter remarks"
                                                                value={formData.Remarks ?? ""}
                                                                disabled
                                                            >
                                                            </textarea>
                                                        </div>
                                                    </div>

                                                    {/* Upload Documents */}
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">View Documents</label>
                                                        <div className="col-8">
                                                            {formData.offboardingDocuments && formData.offboardingDocuments.length > 0 ? (
                                                                <div className="d-flex flex-column gap-2">
                                                                    {formData.offboardingDocuments.map((doc: string, index: number) => (
                                                                        <button
                                                                            key={index}
                                                                            type="button"
                                                                            className="btn btn-outline-primary"
                                                                            onClick={() => window.open(doc, "_blank")}
                                                                        >
                                                                            View Document {index + 1}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <span className="form-control text-muted text-center">No Documents</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">Last Working Date
                                                            {/* <sup className="text-danger">*</sup> */}
                                                        </label>
                                                        <div className="col-8">
                                                            <DatePicker
                                                                className="form-control datetimepicker"
                                                                format="DD MMMM YYYY"
                                                                value={formData.LastWorkingDate ? dayjs(formData.LastWorkingDate, "YYYY-MM-DD") : null}
                                                                disabledDate={(current) => current && current < dayjs().startOf("day")}
                                                                onChange={(date) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        LastWorkingDate: date ? date.format("YYYY-MM-DD") : null
                                                                    }))
                                                                }
                                                            // required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">Manager Remarks
                                                            <sup className="text-danger">*</sup>
                                                        </label>
                                                        <div className="col-8">
                                                            <textarea className="form-control" required
                                                                value={formData?.ManagerRemark ?? ""}
                                                                placeholder="Enter Remarks"
                                                                onChange={(e) => setFormData((prev) => ({
                                                                    ...prev,
                                                                    ManagerRemark: e.target.value
                                                                }))}>

                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                {is_manager === "true" && formData.Status === "Pending" ? (
                                    <div className="d-flex justify-content-end my-3">
                                        <button
                                            // to="/resgination/add-form"
                                            // to={"#"}
                                            type="submit"
                                            onClick={() => setApprovalStatus("Approved")}

                                            className="btn btn-primary custom_button d-flex align-items-center"
                                        >
                                            {" "}
                                            Accept
                                        </button>
                                        <button
                                            type="submit"
                                            onClick={() => setApprovalStatus("Rejected")}
                                            className="btn btn-primary custom_button d-flex align-items-center mx-2"
                                        >
                                            {" "}
                                            Retain
                                        </button>
                                    </div>

                                ) : (
                                    <>
                                    </>
                                )}
                            </form>
                        </div>)
                        : (<div
                            className="card d-flex justify-content-center align-items-center text-center"
                            style={{ minHeight: "250px" }}
                        >
                            <h6 className="text-muted">No Data Available</h6>
                        </div>)
                    }
                </div >

                {/* Footer */}
                < div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3" >
                    <p className="mb-0">© {new Date().getFullYear()}. All rights reserved.</p>
                </div >
            </div >
        </>
    )
}

export default ManagerViewResignation